// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilGrayXLight":"#D1D4D6","wrapper":"style_wrapper__2XomA"};